import { ref, watch } from "vue";
import type { Ref } from "vue";
import useSetter from "@/composables/useSetter";
/**
 * @function useDefaultValue - function that creates a specific type ref value,
 * mostly intended for props with no default initialization, but with a needed value for component functioning
 * @param {Ref<ValueType | undefined> | undefined} initialValue - initial ref
 * @param {ValueType} defaultValue - predefined default value
 * @returns the new ref, that depends on the initial value and itself
 */
export default function useDefaultValue<ValueType>(
  initialValue: Ref<ValueType | undefined> | undefined,
  defaultValue: ValueType
): Ref<ValueType> {
  //if the initialValue is defined and its a ref with a defined value set it, otherwise use the defaultValue
  const { value, setter } = useSetter(
    ref(
      initialValue
        ? initialValue.value
          ? initialValue.value
          : defaultValue
        : defaultValue
    )
  );

  //if the initialValue changes, modify the value accordingly
  if (initialValue) {
    watch(initialValue, (newValue) => setter(newValue));
  }
  return value as Ref<ValueType>;
}
